import LoadingSpinner from './LoadingSpinner'

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/UI/LoadingSpinner/index.js